<template>
  <div class="dashboard page">
    <div class="page-title">
      <span>Dashboard Page</span>
      <div class="choose-currency">
        <select v-if="$route.name !== 'global'" name="currency" v-model="currency" @change="selectCurrency">
          <option v-if="getStoreConfig() && !isNotUseStoreCurrency(getStoreConfig().currency)" :value="null">{{ getStoreConfig().currency }}</option>
          <option
            v-for="rate in (getCurrencyRates)"
            :value="rate.toCurrency"
            :key="rate.id"
          >
          {{ rate.toCurrency }}
          </option>
        </select>
      </div>
    </div>
    <UiFilterbar @onDefaultFilter="onDefaultFilter" @onFilterDay="onDefaultFilter" @onChangeOutlet="onChangeOutlet" :disableCompareDate="false" :queryMode="this.query.mode"/>
    <div class="column-filter-wrapper">
      <button class="btn btn-csv customize-button" @click="toggleColumnFilter()">
        {{ $t('customize') }}
      </button>
      <ul ref="columnsList">
        <li
          v-for="field in fields"
          :key="field.key"
        >
          <label v-bind:for="field.key">
              <input type="checkbox" v-model="field.visible" v-bind:id="field.key">
              <span>{{ field.label }}</span>
          </label>
        </li>
      </ul>
    </div>
    <UiDashboardChart :report="report" :dataSeries="prepareChartSeries(report)" :options="prepareChartOptions(report)" :colsData="visibleFields"/>
    <div class="product-sold-chart" v-if="paymentReport && paymentReport.items && typeof (report.items) === 'object'">
      <a href="/payment" class="item-title">
        {{ $t("payment_method") }}
      </a>
      <UiChart :series="preparePaymentChartSeries(paymentReport)" :options="preparePaymentChartOptions(paymentReport)"/>
    </div>
  </div>
</template>

<script>
import * as _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import { getItemByLocalStorage, setLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'
import moment from 'moment'
import UiFilterbar from '@/components/filterBar/UiFilterbar'
import UiChart from '@/components/UiChart'
import UiDashboardChart from '@/components/UiDashboardChart'
import reportType from '@/config/reportType'
import i18n from '@/i18n'
export default {
  name: 'DashBoardPage',
  components: {
    UiFilterbar,
    UiChart,
    UiDashboardChart
  },
  data () {
    const timeZone = Number.isInteger(Number(new Date().getTimezoneOffset()) / 60) ? (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60}`.padStart(2, 0)}:00` : `-${Number(new Date().getTimezoneOffset()) / 60}:00`) : (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Math.trunc(Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60)}`.padStart(2, 0)}:30` : `-${Math.trunc(Number(new Date().getTimezoneOffset()) / 60)}:30`)
    return {
      currency: null,
      day: {},
      query: {
        page: 1,
        limit: 20,
        mode: 'DATE',
        outletIds: null,
        registerIds: null,
        timeZone,
        reportingMode: 'in_store'
      },
      filterType: 'DATE',
      type: 'products',
      isShowColumnsSelect: false,
      fields: [
        { key: 'totalRevenue', label: i18n.t('total_revenue'), visible: true, route: 'total-revenue' },
        { key: 'totalTax', label: i18n.t('tax'), visible: true, route: 'tax' },
        { key: 'netRevenue', label: i18n.t('net_revenue'), visible: true, route: 'net-revenue' },
        { key: 'avgOrderValue', label: i18n.t('avg_order_value'), visible: true, route: 'average-order-value' },
        { key: 'orderCount', label: i18n.t('number_of_orders'), visible: true, route: 'number-of-orders' },
        { key: 'avgItemCount', label: i18n.t('avg_number_of_item_per_order'), visible: true, route: 'average-item-per-order' },
        { key: 'revNewCustomer', label: i18n.t('new_customer'), visible: true, route: 'revenue-by-customer' },
        { key: 'revReturnCustomer', label: i18n.t('returning_customer'), visible: true, route: 'revenue-by-customer' },
        { key: 'totalRefund', label: i18n.t('refund'), visible: true, route: i18n.t('refund') },
        { key: 'totalDiscount', label: i18n.t('discount'), visible: true, route: i18n.t('discount') }
      ],
      filteredFields: []
    }
  },
  computed: {
    ...mapGetters({
      report: 'report/getReportData',
      paymentReport: 'report/getPaymentReportData',
      productReport: 'report/getProductReportData',
      getCurrencies: 'currency/getCurrencies',
      getCurrencyRates: 'currency/getCurrencyRates'
    }),
    visibleFields () {
      return this.fields.filter(field => field.visible)
    }
  },
  methods: {
    ...mapActions({
      getReport: 'report/getReportDataByStore'
    }),
    selectCurrency () {
      const currencyRate = this.getCurrencyRates.find(rate => rate.toCurrency === this.currency)

      if (currencyRate) {
        const currencySelected = this.getCurrencies.find(currencyItem => this.currency === currencyItem.code)
        const symbol = currencySelected.currency_symbol || this.currency
        var isBaseCurrency = this.getStoreConfig().currency && this.isNotUseStoreCurrency(this.getStoreConfig().currency) && this.currency === this.getStoreConfig().currency
        setLocalStorage(localStorageKey.CURRENT_CURRENCY, { ...currencyRate, symbol, rate: isBaseCurrency ? 1 : currencyRate.rate })
      }

      if (!this.currency && getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)) {
        const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
        const currencySelected = this.getCurrencies.find(currencyItem => storeConfig?.currency === currencyItem.code)
        const symbol = currencySelected.symbol
        setLocalStorage(localStorageKey.CURRENT_CURRENCY, {
          fromCurrency: storeConfig?.currency,
          toCurrency: storeConfig?.currency,
          rate: 1,
          symbol
        })
      }
      
      this.getReport({
        type: reportType.saleSummary,
        query: {
          ...this.query,
          ...this.day
        }
      })
      this.getReport({
        type: reportType.payment,
        query: {
          ...this.query,
          ...this.day
        }
      })
    },
    getStoreConfig () {
      return getItemByLocalStorage(localStorageKey.STORE_CONFIG)
    },
    onChangeOutlet (reportingMode, outletIds, registerIds, day, type, states, statuses) {
      this.day = day
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.saleSummary,
        query: {
          ...this.query,
          ...day
        }
      })
      this.getReport({
        type: reportType.payment,
        query: {
          ...this.query,
          ...day
        }
      })
    },
    onDefaultFilter (day, type, source, outletIds, registerIds) {
      this.day = day
      this.filterType = type
      this.query.mode = type
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.getReport({
        type: reportType.saleSummary,
        query: {
          ...this.query,
          ...day
        }
      })
      this.getReport({
        type: reportType.payment,
        query: {
          ...this.query,
          ...day
        }
      })
    },
    toggleColumnFilter () {
      const el = this.$refs.columnsList
      el.classList.toggle('show')
    },
    formartDate (date) {
      if (date.length < 8) return date
      return moment(new Date(moment(date).toDate().toUTCString())).format('MMM DD YYYY')
    },
    convertKeyToText (key) {
      return key.replace(/([A-Z])/g, ' $1').trim()
    },
    prepareChartOptions (reports) {
      const dateList = reports && reports.items ? Object.keys(reports.items).map(item => this.formartDate(item)) : []
      return {
        chart: {
          id: 'product-sold-chart',
          zoom: {
            enabled: false
          }
        },
        stroke: {
          width: 2
        },
        markers: {
          size: 4,
          hover: {
            size: 7,
            sizeOffset: 3
          }
        },
        noData: {
          text: 'No data'
        },
        xaxis: {
          categories: dateList
        }
      }
    },
    formatTotalWithoutPrefix (total, currencyExchangeRate = null, presentmentCurrency = null) {
      const currentCurrent = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY) || {}
      const toCurrencyKey = 'toCurrency'
      const toCurrency = currentCurrent[toCurrencyKey]
      var rate = presentmentCurrency && currencyExchangeRate && (toCurrency === presentmentCurrency) ? currencyExchangeRate : (currentCurrent?.rate || '1')
      return (Number(total) * Number(rate))
    },
    prepareChartSeries (reports) {
      const dataList = {}
      this.visibleFields.forEach(field => {
        dataList[field.key] = []
        const fieldData = []
        const fieldDataTotal = []
        reports.items && Object.keys(reports.items).forEach(item => {
          fieldDataTotal.push({ value: reports.items[item][field.key] ? parseFloat(reports.items[item][field.key]).toFixed(6) : 0, data: reports.items[item] })
          let valueChart = 0
          if (field.key === 'orderCount' || field.key === 'avgItemCount') {
            valueChart = reports.items[item][field.key] ? parseFloat(reports.items[item][field.key]) : 0
          } else {
            valueChart = this.formatTotalWithoutPrefix(reports.items[item][field.key] ? parseFloat(reports.items[item][field.key]).toFixed(6) : 0, reports.items[item] && reports.items[item].currencyExchangeRate ? reports.items[item].currencyExchangeRate : null, reports.items[item] && reports.items[item].presentmentCurrency ? reports.items[item].presentmentCurrency : null)
          }
          fieldData.push(valueChart.toFixed(2))
        })

        dataList[field.key].push({
          name: this.convertKeyToText(field.key),
          data: fieldData,
          dataTotal: fieldDataTotal
        })
      })
      return dataList
    },
    prepareProductChartOptions (reports) {
      const productList = reports && reports.items ? reports.items.map(item => item.name) : []

      return {
        chart: {
          id: 'product-sold-chart',
          type: 'bar',
          width: productList.length < 50 ? '100%' : Math.max(document.body.offsetWidth - 60, productList.length * 30),
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              customIcons: []
            },
            autoSelected: 'zoom'
          },
          zoomOptions: {
            enabled: true,
            type: 'x',
            resetIcon: {
              offsetX: -10,
              offsetY: 0,
              fillColor: '#fff',
              strokeColor: '#37474F'
            },
            selection: {
              background: '#90CAF9',
              border: '#0D47A1'
            }
          }
        },
        noData: {
          text: 'No data'
        },
        plotOptions: {
          bar: {
            columnWidth: productList.length === 1 ? '15%' : productList.length <= 3 ? '30%' : '70%'
          }
        },
        tooltip: {
          x: {
            formatter: (name) => name
          }
        },
        xaxis: {
          categories: productList,
          labels: {
            formatter: function (value) {
              if (value.length > 10) return value.substring(0, 10) + '...'
              return value
            }
          }
        }
      }
    },
    prepareProductChartSeries (reports) {
      const valueList = reports && reports.items ? reports.items.map(item => item.netQtySold) : []
      return [{
        name: 'Net Quantity Sold',
        data: valueList
      }]
    },
    preparePaymentChartOptions (reports) {
      const dateList = reports && reports.items ? Object.keys(reports.items).map(item => this.formartDate(item)) : []

      return {
        chart: {
          id: 'product-sold-chart',
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        stroke: {
          width: 2
        },
        colors: ['#F3B415', '#F27036', '#663F59', '#6A6E94', '#4E88B4', '#00A7C6', '#18D8D8', '#A9D794',
          '#46AF78', '#A93F55', '#8C5E58', '#2176FF', '#33A1FD', '#7A918D', '#BAFF29'
        ],
        markers: {
          size: 4,
          hover: {
            size: 7,
            sizeOffset: 3
          }
        },
        noData: {
          text: 'No data'
        },
        xaxis: {
          categories: dateList
        }
      }
    },
    preparePaymentChartSeries (reports) {
      let paymentList = []
      if (reports && reports.items) {
        Object.keys(reports.items).map(item => {
          paymentList = _.union(paymentList, Object.keys(reports.items[item]))
        })
      }

      const dataList = []
      paymentList.forEach(payment => {
        const paymentData = {
          name: payment,
          data: []
        }
        Object.keys(reports.items).forEach(item => {
          paymentData.data.push(reports.items[item][payment] ? parseFloat(reports.items[item][payment]).toFixed(2) : 0)
        })
        dataList.push(paymentData)
      })

      return dataList
    },
    isNotUseStoreCurrency (currency) {
      if (currency && currency.length && this.getCurrencyRates && this.getCurrencyRates.length > 0) {
        const existCurrency = this.getCurrencyRates.find(currencyItem => currency === currencyItem.toCurrency)
        return !!existCurrency
      }
      return false
    }
  },
  created () {
    if (getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)) {
      this.currency = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY).toCurrency
    } else {
      if (this.getCurrencyRates && this.getCurrencyRates.length > 0) {
        const currencyRate = this.getCurrencyRates[0]
        if (currencyRate) {
          const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
          const currencySelected = this.getCurrencies?.find(currencyItem => storeConfig?.currency === currencyItem.code)
          if (currencySelected) {
            const symbol = currencySelected.symbol
            setLocalStorage(localStorageKey.CURRENT_CURRENCY, {
              fromCurrency: storeConfig?.currency,
              toCurrency: storeConfig?.currency,
              rate: 1,
              symbol
            })
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .page-title {
    font-size: 36px;
    line-height: 49px;
    margin-bottom: 25px;
    display: flex;
    justify-content: space-between;
    select {
      padding: 0 15px;
      margin: 0;
      height: 39px;
      min-width: 140px;
      outline: none;
      border-radius: 4px;
      border: 1px solid #818181;
      background-color: #fff;
      margin-right: 30px;
    }
  }
  .customize-button {
    min-width: 140px;
    font-size: 13px;
    font-weight: 600;
    outline: none;
  }
  .column-filter-wrapper {
    text-align: right;
    position: relative;
    margin-bottom: 20px;
    padding: 0 30px;
  }
  ul {
    position: absolute;
    text-align: left;
    right: 0;
    background: #e9eef1;
    padding: 20px;
    top: 100%;
    border: 1px solid #acacac;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    z-index: 12;
    display: none;

    &.show {
      display: block;
    }

    li {
      padding: 5px 0;

      label {
        cursor: pointer;
      }
    }
  }
  .item-title {
    padding: 0 10px;
    margin-right: 2rem;
    margin-bottom: 25px;
    line-height: 1em;
    font-size: 16px;
    font-weight: 700;
    color: #000;
    text-transform: capitalize;
    cursor: pointer;
    text-decoration: none;
  }
  .product-sold-chart {
    background-color: #FFFFFF;
    padding-top: 15px;
    margin-bottom: 25px;
    overflow: auto;
  }
</style>
